import React from 'react'
import {
  Box,
  CircularProgress,
  Grid,
  useMediaQuery,
  useTheme
} from '@mui/material'
import '../dashboard/dashboard.css'
import Card from '../../leastcomponent/cardInfo/card'
import TableWrapper from '../../leastcomponent/dashboardTableWrapper/TableWrapper'
import Activity from '../../leastcomponent/Activity/Activity'
import RecentActivityCard from '../../leastcomponent/Activity/RecentActivityCard'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'
import DateRange from '../../leastcomponent/daterabgepicker/customdaterangepicker'
import moment from 'moment'
import {
  useAdminAllCount,
  useAdminBreakDown,
  useAdminDashboardRecentActivity,
  useAdminDashboardTaskOverview,
  useAdminMachineList
} from '../../hooks/dashboard'
import MachineBarChart from '../../leastcomponent/barChart/MachineBarChart'
import ManufacturedBarChart from '../../leastcomponent/barChart/ManufacturedBarChart'
import MachineOverviewPieChart from '../../leastcomponent/piechart/MachineOverviewPieChart'
import { useNavigate } from 'react-router-dom'

const AdminDashBoard = () => {
  const currentDate = moment()
  const navigate = useNavigate()
  const weekStart = currentDate.clone().startOf('today')
  const weekEnd = currentDate.clone().endOf('today')
  const [ganttDates, setGranttDatesState] = React.useState({
    startDate: moment(weekStart).format('DD MMM, YY'),
    endDate: moment(weekEnd).format('DD MMM, YY')
  })
  const setGranttDates = (e, { startDate, endDate }) => {
    setGranttDatesState({
      startDate: startDate.format('DD MMM, YY '),
      endDate: endDate.format(' DD MMM, YY')
    })
  }

  // dashboard recent activity api useDashboardRecentActivity
  const { data: dashboardRecentData, isFetching: isDashboardRecentData } =
    useAdminDashboardRecentActivity()
  const dashboardRecent = dashboardRecentData?.data

  // count data like parts,jobcards,task,breakdown
  const { data: adminAllCount } =
    useAdminAllCount()
  const adminAllCountData = adminAllCount?.data

  // JobcardStatus wise table api
  const {
    data: dashboardBreakDown,
    isFetching: isDashboardBreakDown
  } = useAdminBreakDown(
    true,
    ganttDates
  )
  const rowsBreakDown = dashboardBreakDown?.[0]?.tasks?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.id,
      machine: data?.resource?.name ? data?.resource?.name : '-',
      machineCode: data?.resource?.code ? data?.resource?.code : '-',
      breakdownTime: moment(data?.breakdownTime).format('MM/DD/YY, hh:mm A') ? moment(data?.breakdownTime).format('MM/DD/YY, hh:mm A') : '-',
      breakdown: '12h'
    }
  })

  const {
    data: adminMachineList,
    isFetching: isAdminMachineList
  } = useAdminMachineList(
    // true,
    // ganttDates
  )
  const listMachine = adminMachineList?.data
  const rowsAdminMachine = listMachine?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.id,
      allocatedTime: data?.allocatedTime ? data?.allocatedTime : '-',
      completedTime: data?.completedTime ? data?.completedTime : '-',
      name: data?.name ? data?.name : '-',
      utilisation: data?.utilisation ? data?.utilisation : '-'
    }
  })
  const {
    data: dashboardTaskOverview,
    isFetching: isDashboardTaskOverView
  } = useAdminDashboardTaskOverview(
    // true,
    // ganttDates
  )
  const rowsOverview = dashboardTaskOverview?.map((data, index) => {
    return {
      no: index + 1,
      id: data?.id,
      department: data?.name ? data?.name : '0',
      pandingTask: data?.pendingTask ? data?.pendingTask : '0',
      completedTask: data?.completedTask ? data?.completedTask : '0',
      ongoingTask: data?.ongoingTask ? data?.ongoingTask : '0'
    }
  })

  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const overviewColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.2 : 0 },
    { field: 'department', headerName: 'Department', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'pandingTask',
      headerName: 'Pending Tasks',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    { field: 'ongoingTask', headerName: 'Ongoing Tasks', flex: matches ? 1 : 0.7 },
    { field: 'completedTask', headerName: 'Completed Tasks', flex: matches ? 1 : 0.7 }
  ]
  const breakDownColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.2 : 0 },
    { field: 'machine', headerName: 'Machine Name', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'machineCode',
      headerName: 'Machine Code',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    { field: 'breakdown', headerName: 'Breakdown Duration', flex: matches ? 1 : 0.7 },
    { field: 'breakdownTime', headerName: 'Breakdown Occurred', flex: matches ? 1 : 0.7 },
    {
      field: 'reason',
      headerName: 'Reason',
      flex: matches ? 1 : 0.7,
      renderCell: (params) => {
        return (
          <span
          onClick={() => { navigate('/resource', { state: { activeTab: '4' } }) }} style={{ color: 'blue' }}>
             View
          </span>
        )
      }
    }
  ]
  const machineListColumns = [
    { field: 'no', headerName: '#', width: 70, flex: matches ? 0.2 : 0 },
    { field: 'name', headerName: 'Machines', width: 150, flex: matches ? 1 : 0.7 },
    {
      field: 'allocatedTime',
      headerName: 'Allocated Time',
      width: 150,
      flex: matches ? 1 : 0.7
    },
    { field: 'completedTime', headerName: 'Completed Time', flex: matches ? 1 : 0.7 },
    { field: 'utilisation', headerName: 'Utilisation %', flex: matches ? 1 : 0.7 }
  ]

  const columnChartData = [
    {
      name: 'Time (hrs)',
      color: '#ABE6FF',
      data: [
        {
          name: 'week 1',
          y: 28
        },
        {
          name: 'week 2',
          y: 17
        },
        {
          name: 'week 3',
          y: 15
        },
        {
          name: 'week 4',
          y: 24
        },
        {
          name: 'week 5',
          y: 20
        },
        {
          name: 'week 6',
          y: 28
        }
        // {
        //   name: 'week 7',
        //   y: 80
        // }
      ]
    }
  ]

  return (
    <React.Fragment>
      <Box className="dash-border-main-box">
        <Box>
          <BreadcrumbNavigation
            breadCrumbData={null}
            pageTitle={'Dashboard'}
            backToLink={null}
          />
        </Box>
        <Box className="dash-border-box-over">
          <Box sx={{ padding: '16px 20px', display: 'flex', gap: '10px' }}>
            <Box>
              <DateRange
                setDatesState={setGranttDatesState}
                dates={ganttDates}
                setDates={setGranttDates}
              />
            </Box>
          </Box>
          <Box sx={{ padding: '16px 20px' }}>
            <Grid container className="parent-details-info" spacing={0} >
              {/* Left Section */}
              <Grid item xs={12} md={8}>
               <Grid container spacing={2}>
                   <Grid item xs={6} md={3}>
                    <Card title={'Total Job Card'} data={adminAllCountData?.totalJobCards} />
                   </Grid>
                  <Grid item xs={6} md={3}>
                    <Card title={'Total Parts'} data={adminAllCountData?.totalBomparts} />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Card title={'Total Tasks'} data={adminAllCountData?.totalTasks} />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Card title={'Total Breakdowns'} data={adminAllCountData?.totalBreakdown} />
                   </Grid>
                  {/* Job Card Status */}
                  <Grid item xs={12}>
                    {!isDashboardTaskOverView
                      ? (
                      <TableWrapper
                        rows={rowsOverview}
                        columns={overviewColumns}
                        isShowFiveRecords={true}
                        title="Task Overview"
                        isBottomTitle={true}
                        showTotalTasks={false}
                        showTotalParts={false}
                      />
                        )
                      : (
                      <Box className="progress-parent-dashboard-table">
                        <CircularProgress />
                      </Box>
                        )}
                  </Grid>
                  <Grid item xs={12} >
                  <MachineBarChart
                  title="Machine Time"
                  type="column"
                  // seriesData={seriesData}
                  // machineData={machineData}
                  isGridLine={true}
                  height="278"
                />
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Section */}
              <Grid
                item
                xs={12}
                md={4}
              >
                <Box style={{
                  marginLeft: '12px',
                  border: '1px solid #DEDEDE',
                  // borderRadius: '8px',
                  height: '100%'
                }}>
                {!isDashboardRecentData
                  ? (
                  <Activity
                    Component={RecentActivityCard}
                    // height={'533px'}
                    title={'Recent Activity'}
                    isViewAll={true}
                    viewAllLink={'/recent-activity'}
                    data={dashboardRecent || []}
                  />
                    )
                  : (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%'
                    }}
                  >
                    <CircularProgress />
                  </Box>
                    )}
                </Box>

                </Grid>
                </Grid>
             <Grid container spacing={2} className="parent-details-info">
                {/* Left Section: TableWrapper */}
                <Grid item xs={12} md={8} lg={8} className="parent-spacing">
                  {!isDashboardBreakDown
                    ? (
                    <TableWrapper
                      rows={rowsBreakDown}
                      columns={breakDownColumns}
                      isShowFiveRecords={true}
                      title="Breakdown List"
                      totalParts={dashboardBreakDown?.[0]?.totalBomParts}
                      totalTasks={dashboardBreakDown?.[0]?.totalTask}
                    />
                      )
                    : (
                    <Box className="progress-parent-dashboard-table">
                      <CircularProgress />
                    </Box>
                      )}
                </Grid>

                      {/* Right Section: ManufacturedBarChart */}
                      <Grid item xs={12} md={4} marginTop={2}>
                        <ManufacturedBarChart
                          title="Manufactured Parts"
                          type="column"
                          data={columnChartData}
                          isGridLine={true}
                          height="250"
                        />
                      </Grid>
                         </Grid>

            <Grid container spacing={2} className="parent-details-info">
               {/* Left Section: TableWrapper */}
               <Grid item xs={12} md={8} lg={8} className="parent-spacing">
                 {!isAdminMachineList
                   ? (
                   <TableWrapper
                     rows={rowsAdminMachine}
                     columns={machineListColumns}
                     isShowFiveRecords={true}
                     title="Machines"
                      isBottomTitle={true}
                      showTotalTasks={false}
                      showTotalParts={false}
                   />
                     )
                   : (
                   <Box className="progress-parent-dashboard-table">
                     <CircularProgress />
                   </Box>
                     )}
               </Grid>

               {/* Right Section: ManufacturedBarChart */}
               <Grid item xs={12} md={4} marginTop={2}>
                 <MachineOverviewPieChart
                   title="Machine Overview"
                   type="column"
                  //  data={columnChartData}
                   isGridLine={true}
                   height="250"
                 />
               </Grid>
             </Grid>

          </Box>
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default AdminDashBoard
